import { DateTimeFormatter } from "@js-joda/core";
class Formatter {
    static currencyFormatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
    });
    static timeFormatter = DateTimeFormatter.ofPattern("HH:mm");
    static time(input) {
        return input ? input.format(this.timeFormatter) : "";
    }
    static currency(input) {
        if (input === undefined || input === null) {
            return "";
        }
        return this.currencyFormatter.format(input);
    }
    static date(input) {
        return input ? input.toLocaleDateString('de-DE', { day: "2-digit", month: "2-digit", year: "numeric" }) : "";
    }
    static dateTime(input) {
        return input ? this.date(input) + " " + input.toLocaleTimeString() : "";
    }
    static isoDate(input) {
        return input ? input.toISOString().split('T')[0] : null;
    }
    static decimalToPercent(input) {
        return input ? (input * 100).toFixed(2) + "%" : "";
    }
    static timeslot(timeslot) {
        if (!timeslot)
            return '';
        return `${timeslot.startTime.toString()} - ${timeslot.endTime.toString()}`;
    }
}
export { Formatter };
